export default __webpack_public_path__ + "static/media/icons.f669d070.svg";